import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContinueShoppingComponent } from './continue-shopping.component';
import { ButtonModule } from '../button/button.module';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { GetRouteModule } from '@thema-core/pipes';

@NgModule({
  declarations: [ContinueShoppingComponent],
  imports: [CommonModule, ButtonModule, RouterModule, TranslocoModule, GetRouteModule],
  exports: [ContinueShoppingComponent],
})
export class ContinueShoppingModule {}
